<template>
    <div class="wrapBox">
        <div class="piccBg"></div>
        <div class="wrap">
            <div class="claimsDiv">
                <table id="policy"
                       border="1"
                       bordercolor="#d0d0d0"
                       cellspacing="0"
                       cellpadding="0">
                    <tr>
                        <th colspan="2">
                            <div class="titDiv">
                                <p class="tit">{{$t('message.valueAddedService')}}&ensp;&ensp;{{$t('message.goodsExtensionInsurance')}}</p>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td>{{$t('message.insuranceBillCode')}}</td>
                        <td>
                            <span id="policyNumber">{{policyNumber}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.waybillNumber')}}</td>
                        <td>
                            <span id="wayBillCode">{{wayBillCode}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.bookingDepartureDate')}}</td>
                        <td>
                            <span id="bookingShippingDate">{{bookingShippingDate}}</span>
                        </td>
                    </tr>
                    <tr style="display: none;">
                        <td>{{$t('message.actualSailingDate')}}</td>
                        <td>
                            <span id="realShippingDate">{{realShippingDate}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.theInsured')}}</td>
                        <td>
                            <span id="insured">{{insured}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.certificateType')}}</td>
                        <td>
                            <span id="certType">{{certType}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.certificateNumber')}}</td>
                        <td>
                            <span id="certNumber">{{certNumber}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.compensationRatio')}}</td>
                        <td>
                            <span>{{$t('message.carriage')}}*<span id="claimsProportion">{{claimsProportion}}</span>%</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.rate')}}</td>
                        <td>
                            <span><span id="rates">{{rates}}</span>%</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.carriage')}}</td>
                        <td>
                            <span id="freightFee">{{freightFee}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.premium')}}</td>
                        <td>
                            <span id="insuranceFee">{{insuranceFee}}</span>
                        </td>
                    </tr>
                    <tr v-show="policyType === '1'" class="claimsTr">
                        <td>{{$t('message.compensationAmount')}}</td>
                        <td>
                            <span id="claimsFee">{{claimsFee}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.insurer')}}</td>
                        <td>
                            <span>{{$t('message.branchOdPICC')}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.insuranceClause')}}</td>
                        <td>
                            <el-button type="text" @click="protocolClick">《{{$t('message.exceptions')}}》</el-button>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.claimsProcess')}}</td>
                        <td>
                            <p>{{$t('message.claimsProcessInfo1')}}</p>
                            <p>{{$t('message.claimsProcessInfo2')}}</p>
                            <p>{{$t('message.claimsProcessInfo3')}}</p>
                            <p>{{$t('message.claimsProcessInfo4')}}</p>
                            <p>{{$t('message.claimsProcessInfo5')}}</p>
                            <table id="claimsTab"
                                   border="1"
                                   bordercolor="#d0d0d0"
                                   cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td class="tit" rowspan="3">
                                        <span>{{$t('message.claimsDatumTitle')}}</span>
                                    </td>
                                    <td>{{$t('message.claimsDatum1')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.claimsDatum2')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.claimsDatum3')}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
                <div v-show="policyType === '1'" id="confirmClaimsIcon"></div>
                <div v-show="policyType === '2'" id="cancelClaimsIcon"></div>
            </div>
            <SJMLoading v-if="isLoading"></SJMLoading>
        </div>
        <GoodsExtensionInsuranceProtocolDialog
                :show="isShowProtocolDialog"
                :isShowConfirm="false"></GoodsExtensionInsuranceProtocolDialog>
    </div>
</template>
<script>

    import GoodsExtensionInsuranceProtocolDialog
        from '@/components/personalCenter/GoodsExtensionInsuranceProtocolDialog.vue';// 货延险协议弹窗

    export default {
        name: 'CertificateOfInsurance',// 保单页
        components: {
            GoodsExtensionInsuranceProtocolDialog
        },
        data() {
            return {
                isLoading: true,// 加载中
                isShowProtocolDialog: -1,// 显示协议弹窗
                orderBillCode: this.$route.query.orderBillCode,// 托单号
                policyType: '0',// 理赔标志 0-无需理赔、1-需赔付、2-已取消
                policyNumber: '',// 保单号
                wayBillCode: '',// 运单编号（若无返回：— —）
                bookingShippingDate: '',// 订舱开航日期
                realShippingDate: '',// 实际开航日期 （若无返回：— —）
                insured: '',// 被保险人
                certType: '',// 证件类型
                certNumber: '',// 证件号码
                claimsProportion: '',// 赔付比例
                rates: '',// 费率
                freightFee: '',// 运费（有预计or实际）
                insuranceFee: '',// 保费（有预计or实际）
                claimsFee: ''// 赔付金额（若无返回空字符串）

            };
        },
        created() {
            if (!this.orderBillCode) {
                this.$Alert({
                    msg: this.$t('message.illegalAccess'),
                    callback: () => {
                        this.$router.replace('/');
                    }
                });
                return;
            }
            this.getCargoDelayInsurancePolicyData();// 获取 货延险保单数据
        },
        methods: {
            // 获取 货延险保单数据
            getCargoDelayInsurancePolicyData() {
                this.$ajax({
                    url: '/insuranceHandler/queryinsurance/queryDelayInsuranceHandler.ashx',
                    data: {
                        act: 'getCargoDelayInsurancePolicyData',// 获取 货延险保单数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.isLoading = true;// 开启加载中
                    },
                    success: (res) => {
                        this.policyType = res.success.policyType;// 理赔标志 0-无需理赔、1-需赔付、2-已取消
                        this.policyNumber = res.success.policyNumber;// 保单号
                        this.wayBillCode = res.success.wayBillCode;// 运单编号（若无返回：— —）
                        this.bookingShippingDate = res.success.bookingShippingDate;// 订舱开航日期
                        this.realShippingDate = res.success.realShippingDate;// 实际开航日期 （若无返回：— —）
                        this.insured = res.success.insured;// 被保险人
                        this.certType = res.success.certType;// 证件类型
                        this.certNumber = res.success.certNumber;// 证件号码
                        this.claimsProportion = res.success.claimsProportion;// 赔付比例
                        this.rates = res.success.rates;// 费率
                        this.freightFee = res.success.freightFee;// 运费（有预计or实际）
                        this.insuranceFee = res.success.insuranceFee;// 保费（有预计or实际）
                        this.claimsFee = res.success.claimsFee;// 赔付金额（若无返回空字符串）
                        this.isLoading = false;// 加载中关闭
                    }
                });
            },
            // 协议点击
            protocolClick() {
                this.isShowProtocolDialog = +new Date();
            }
        }
    };
</script>

<style lang="scss" scoped>
    h1 {
        text-align: center;
    }

    .wrapBox {
        position: relative;
        width: 714px;
        margin: 30px auto;
    }

    .wrapBox .piccBg {
        position: relative;
        width: 714px;
        height: 83px;
        background-image: url('~@/assets/img/personalCenter/cargoDelayInsurance/certificateOfInsurance/picc-bg.png');
    }

    .wrap {
        position: relative;
        width: 628px;
        margin: 0 auto;

        /* padding: 10px 0; */
    }

    .wrap .claimsDiv {
        position: relative;
    }

    #confirmClaimsIcon {
        /* display: none; */
        position: absolute;
        top: 20px;
        right: 25px;
        width: 90px;
        height: 90px;
        background-image: url("~@/assets/img/personalCenter/cargoDelayInsurance/certificateOfInsurance/confirmClaims.png");
        background-size: 100%;
        transform: rotate(20deg);
    }

    #cancelClaimsIcon {
        /* display: none; */
        position: absolute;
        top: 20px;
        right: 25px;
        width: 90px;
        height: 90px;
        background-image: url("~@/assets/img/personalCenter/cargoDelayInsurance/certificateOfInsurance/cancelClaims.png");
        background-size: 100%;
        transform: rotate(20deg);
    }

    #policy {
        width: 100%;
        border-collapse: collapse;
    }

    #policy th {
        font-weight: normal;
        text-align: left;
    }

    #policy td {
        padding: 10px;
        text-align: left;
    }

    #policy td:nth-child(1) {
        width: 134px;
        font-size: 13px; /* 16 */
        color: #203864;
    }

    #policy td:nth-child(2) {
        font-size: 13px; /* 16 */
        color: #7e7e7e;
    }

    #policy td #disclaimer {
        font-size: 13px; /* 16 */
        color: #1f9fd7;
    }

    #policy .titDiv {
        height: 40px;
        padding-left: 10px;
        background-color: #d7e5f1;
    }

    #policy .titDiv .tit {
        padding-top: 12px;
        font-size: 13px; /* 16 */
        color: #203864;
    }

    #policy .claimsTr {
        /* display: none; */
        background-color: #d9d9d9;
    }

    #policy .claimsTr td:nth-child(2) span {
        color: red;
    }

    #policy .titDiv .subTit {
        padding-top: 12px;
        font-size: 12px;
        color: #323e50;
    }

    #policy #claimsTab {
        width: 400px;
        margin-top: 18px;
        border-collapse: collapse;
    }

    #policy #claimsTab td {
        font-size: 13px;
        color: #7e7e7e;
    }

    #policy #claimsTab td.tit {
        width: 66px;
        font-size: 13px; /* 16 */
        color: #9b9b9d;
        text-align: center;
        background-color: #f3f3f3;
    }

    #policy #claimsTab td span {
        display: inline-block;
        width: 35px;
    }
</style>
